import type { NextPage } from 'next';
import useUser from '../auth/useUser';
import CompanySelector from 'ui/components/companySelector/company-selector';

const Home: NextPage = () => {
  const user = useUser();
  return (
    <CompanySelector
      user={user}
      options={{
        gascaribe: {
          path: '/gdc',
          role: 'access_gdc',
        },
        gasguajira: {
          path: '/gdg',
          role: 'access_gdg',
        },
        efigas: {
          path: '/efg',
          role: 'access_efg',
        },
      }}
    />
  );
};

export default Home;
